angular.module('rjmNg.directives').directive "characterCounter", [() ->
  template: "<span ng-transclude></span>
  			<span class='badge' ng-class=\"{'badge-important': currentLength > maxLength}\">
  				{{maxLength - currentLength}}
  			</span>"
  restrict: "A"
  transclude: true
  scope:
    maxLength: "="
    currentLength: "="
]
